<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="原因说明" >
						<emun name="inventoryquantityadjustreason" v-model="form.reason" :cascader="true" :emptyoption="false" />
					</el-form-item>
					<el-form-item label="其他">
						<el-input type="textarea" maxlength="100" :autosize="{ minRows: 10}"
							v-model="form.reason2"></el-input>
					</el-form-item>
				</el-form>

			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="提交" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import emun from '@_system/components/formcomponents/common/select/emun/select.vue'
	export default {
		mixins: [modalMixins],
		props: {
			row: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				form: {
					reason: null,
					reason2: null,
				},
				options: [],
				modal_title: '原因说明',
				modal_width: 600,
				modal_height: 500,
				list_footerField: [{
					field: 'needamount',
					toFixed: 2
				}]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.form = {
					reason: null,
					reason2: this.row.reason,
				}
			},
			submit() {
				let reason = this.form.reason
				if(Array.isArray(reason)){
					reason = this.form.reason[this.form.reason.length-1]
					reason = window.systemMethods.getEmunValue('inventoryquantityadjustreason',reason)
				}
				this.$api.inventoryquantityadjust.updatefromlist(this.row.id,{
					reason : reason,
					reason2 : this.form.reason2
				}).then(()=>{
					this.$emit('success')
					this.modal_cancel()
					
				})
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			emun
		}
	}
</script>